import { http } from '@/utils'

const state = {
  applications: [],
  latestVersions: {
    vue: null,
    laravel: null
  }
}

const actions = {
  async getApplications ({ commit }, params) {
    const response = await http.get('dependencies/applications', { params })

    commit('SET_APPLICATIONS', response.data.data)
    commit('SET_LATEST_VERSIONS', response.data.meta.latest_versions)
  }
}

const mutations = {
  SET_APPLICATIONS (state, applications) {
    state.applications = applications
  },

  SET_LATEST_VERSIONS (state, latestVersions) {
    state.latestVersions = latestVersions
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
